<div>
    <app-table-component [data]="IOTList()" [columns]="tableColumns" [totalRecords]="totalRecords()" [rows]="rows"
        [first]="first" (pageChange)="onPageChange($event)"
        [showColumnSelector]="false" [showClearFilters]="false"
        [searchControl]="searchControl" [customFilters]="[hasCarFilter]" />
</div>

@defer (when addIotDialog; prefetch on idle) {
<app-add-iot-form (addedIot)="onIotAdded()" [(visibility)]="addIotDialog" />
}

@defer (when updateIotDialog; prefetch on idle) {
<app-update-iot-form (updatedIot)="onIotUpdated()" [selectedIOT]="selectedIOT" [(visibility)]="updateIotDialog" />
}

@defer (when deleteIotDialog; prefetch on idle) {
<app-delete-iot-form (deletedIot)="onIotDeleted()" [selectedIOT]="selectedIOT" [(visibility)]="deleteIotDialog" />
}

@defer (when locationDialog; prefetch on idle) {
<app-show-location-dialog [lat]="selectedIOT.position?.latitude ?? 0" [lng]="selectedIOT.position?.longitude ?? 0" [zoom]="17" [(visibility)]="locationDialog" />
}
